<template>
    <v-card
        component="CharacterList"
        :class="{ 'small-design': $vuetify.breakpoint.sm, 'xs-design': $vuetify.breakpoint.xs }"
    >
        <v-card-title class="title">
            <character-create-form v-if="canEdit" />
            <div v-else>Characters</div>
        </v-card-title>

        <v-list v-if="projectHasCharacter" class="py-0">
            <draggable
                v-bind="dragOptions"
                :group="{ name: 'order', pull: 'clone', put: false }"
                :list="getProject.characters"
                :sort="false"
            >
                <character-list-item
                    v-for="(character, index) in getProject.characters"
                    :key="`character-${character.id}-${index}`"
                    :character="character"
                    :can-edit="canEdit"
                />
            </draggable>
        </v-list>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CharacterListItem from '@/components/Project/Character/CharacterListItem.vue';
import CharacterCreateForm from '@/components/Project/Character/CharacterCreateForm.vue';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';

export default {
    name: 'CharacterList',

    props: {
        canEdit: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            dragOptions: {
                ghostClass: 'ghost',
            },
        };
    },

    methods: {
        ...mapActions(['loadActors']),
    },

    computed: {
        ...mapGetters(['getProject', 'getSelectedCharacter', 'projectHasCharacter']),
    },

    watch: {},

    components: {
        CharacterListItem,
        CharacterCreateForm,
        draggable,
        Mp3Player,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='CharacterList'] {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 30%;
    flex: 1;

    .title {
        padding: 6px 15px !important;
        border-radius: 0 !important;
        color: black;
        height: 45px;
    }

    .ghost {
        opacity: 0.7;
        display: flex;
    }
}

[component='CharacterList'] {
    .v-list {
        overflow-y: auto;
        border-radius: 0 !important;
    }

    &.small-design {
        height: auto;
        margin: 0 0 10px 0;

        .v-list {
            height: auto;
        }
    }

    &.xs-design {
        .v-list {
            height: auto;
        }
    }
}
</style>
